module.exports = __webpack_public_path__ + "static/safetylogz-background-small-594102dd0a85071f8d98ac6d6d267d88.svg";